// @ts-check
import { Trans } from '@lingui/macro';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../../components/Layout/Footer';
import Layout from '../../../../../components/Layout/Layout';
import Main from '../../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../../components/Layout/PageHeader';
import MatchSupplier, {
  useMatchSupplier,
} from '../../../../../components/MatchSupplier/MatchSupplier';
import { ProgressIndicator, useLink } from '../_config';

/**
 * @param {object} props
 * @param {import('history').History} props.history
 * @param {{ params: { importId: string, supplierName: string }}} props.match
 */
export default function $SupplierName({ history, match: { params } }) {
  const link = useLink('suppliers');
  const props = useMatchSupplier(params); // This creates all the props for the MatchSupplier component.

  async function handleSubmit() {
    await props.onSubmit();
    // this props are previous data of submit
    // if we have 10 unmatched suppliers and 5th is matched,
    // we need to get the data as it was before the mutation, in
    // order to find the 6th supplier
    // if the user wants to start matching on the 2nd supplier
    // the next would be 3rd till we reach the last unmatched
    // and start from 1st unmatched
    const { unmatchedSuppliers, supplierName } = props;
    const nextSupplierName = getNextSupplierName({
      unmatchedSuppliers,
      supplierName,
    });
    if (nextSupplierName) {
      return history.push(
        link._all.supplier({ supplierName: nextSupplierName })
      );
    }
    history.push(link._all.collection());
  }

  return (
    <Layout>
      <ProgressIndicator step="matchSuppliers" />
      <PageHeader>
        <PageTitle>
          <Trans>Match supplier</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Assign these requested products to an existing partner.</Trans>
        </PageSubtitle>
      </PageHeader>

      <Main columns={3}>
        <MatchSupplier {...props} companyType={null} />
      </Main>

      <Footer>
        <BackButton
          to={link._all.suppliers({ tab: props.isValid ? 'all' : 'unmatched' })}
        />
        <CancelButton to={link.cancel()} />
        <NextButton disabled={!props.isValid} onClick={handleSubmit}>
          <Trans>Save and next</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}

function getNextSupplierName({ unmatchedSuppliers, supplierName }) {
  if (unmatchedSuppliers?.length <= 1) return undefined;
  const currentIndex = unmatchedSuppliers?.indexOf(supplierName);
  if (!unmatchedSuppliers[currentIndex + 1]) {
    return unmatchedSuppliers[0];
  }
  const nextSupplierName = unmatchedSuppliers[currentIndex + 1];
  return nextSupplierName;
}
